/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "lib/commons/registry";
import "lib/commons/utils/user_Perms";
import "lib/core/core_Perms";

const r = REG.reg;
r.newPerm("action.jobsMgr#create.job", "edit.job", 0);
r.newPerm("action.jobsMgr#freeze.executor", "edit.job", 0);
r.newPerm("ui.usersMgr.admin.hiddenGroup", "admin.props.isHidden.group", 0);
r.newPerm("ui.usersMgr.admin.hiddenUser", "admin.props.isHidden.user", 0);
